export function setStorage(name, index, saveOne) {
  let storageData = getStorage(name);
  const itemIndex = fetchIndex(name, index);
  switch (saveOne) {
    case true:
      storageData = [{ key: index }];
      break;

    default:
      if (!isNaN(itemIndex)) {
        storageData.splice(itemIndex, 1);
      } else {
        storageData.push({ key: index });
      }
      break;
  }

  if (localStorage) {
    localStorage.setItem(name, JSON.stringify(storageData));
  }
}

export function getStorage(name) {
  return JSON.parse(localStorage.getItem(name)) || [];
}

export function deleteStorage(name, route, condition, include) {
  if (route && typeof condition === 'object' && condition.indexOf(route) !== -1) return;
  if (include && route && typeof condition === 'object' && condition.find( url => route.includes(url))) return;
  localStorage.removeItem(name);
}

export function fetchIndex(name, index) {
  const storageData = getStorage(name);
  if (storageData?.length === 0) return;
  const itemIndex = !isNaN(index) ? storageData?.findIndex(item => item.key === index) : storageData[0].key;
  if (itemIndex !== -1) return itemIndex;
}
